import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBell01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.223.75 1.984.75.761 0 1.455-.282 1.984-.75a1 1 0 1 1 1.323 1.5A4.984 4.984 0 0 1 12 23a4.984 4.984 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412ZM7.05 3.05A7 7 0 0 1 19 8c0 2.913.732 4.844 1.5 6.077l.011.02c.358.573.64 1.027.83 1.358.096.165.183.325.247.466.032.071.068.158.096.252.024.079.068.246.051.45-.01.136-.039.37-.173.611a1.482 1.482 0 0 1-.428.47c-.25.186-.538.229-.634.243h-.004a4.619 4.619 0 0 1-.483.04c-.336.013-.8.013-1.377.013H5.364c-.577 0-1.041 0-1.376-.013a4.618 4.618 0 0 1-.484-.04H3.5a1.405 1.405 0 0 1-.634-.242 1.48 1.48 0 0 1-.428-.47 1.482 1.482 0 0 1-.173-.613c-.017-.203.027-.37.05-.449.029-.094.065-.18.097-.251a5.66 5.66 0 0 1 .247-.467c.19-.33.472-.785.83-1.359l.012-.019C4.268 12.844 5 10.913 5 8a7 7 0 0 1 2.05-4.95Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgBell01.displayName = 'Bell01';
export default SvgBell01;
